import React from "react"
import { Form } from 'react-bootstrap';
import CheckLegal from "../components/check-legal"

const Newsletter = () => (
	<div className="newsletter">
		<form name="newsletter" method="POST" data-netlify="true" netlify-honeypot="bot-field" action="/gracias-newsletter/">
			<input type="hidden" name="form-name" value="newsletter" />
			<p hidden>
				<label>
					No rellenar si eres humano: <input name="bot-field" />
				</label>
			</p>
			<div className="newsletter-container">
				<Form.Group controlId="nombre" className="form-group form-group-nombre">
					<Form.Label className="label-required">Nombre</Form.Label>
					<Form.Control type="text" name="nombre" required placeholder="Escribe tu nombre" />
				</Form.Group>
				<Form.Group controlId="email" className="form-group form-group-email">
					<Form.Label className="label-required">Email</Form.Label>
					<Form.Control type="email" name="email" required placeholder="Escribe tu e-mail" />
				</Form.Group>
				<button type="submit" className="btn btn-accent">Suscribirme</button>
			</div>
			<CheckLegal />
		</form>
	</div>
)

export default Newsletter